(ns manage.export-tags-ocp.db
  (:require [clojure.spec.alpha :as spec]
            [common.form.core :as form]
            [common.ocp.db]
            [manage.campaign-tags-page.effect :as effect]
            [mate.re-frame :as mr]
            [phrase.alpha :as p]
            [re-frame.core :as rf]))

(def ^:private initial-value
  {:dsp-ids {}
   :additional-settings {:gdpr true
                         :click-tag true}})

(defn- at-least-1-dsp-selected? [dsp-ids]
  (let [selected-dsp-ids (->> dsp-ids
                              (keep (fn [[dsp-id checked]]
                                      (when checked dsp-id))))]
    (pos-int? (count selected-dsp-ids))))

(spec/def ::dsp-ids
  (spec/and (spec/map-of string? any?)
            at-least-1-dsp-selected?))

(spec/def ::value
  (spec/keys :req-un [::dsp-ids
                      ::additional-settings]
             :opt-un [::extra-dsp-signals]))

(p/defphraser at-least-1-dsp-selected?
  [_context problem]
  {:message "At least 1 DSP needs to be selected."
   :ins [(:in problem)]
   :problem problem})

(def validate-form
  (rf/enrich
   (form/get-validate-form-fn :form.export-tags-configuration ::value)))

(form/register-form {:namespace :form.export-tags-configuration
                     :initial-value initial-value
                     :validate-form validate-form
                     :submit-event :form.export-tags-configuration/on-submit-button-clicked})

(def use-bind-control (partial form/use-bind-control :form.export-tags-configuration))
(def use-error-message (partial form/use-error-message :form.export-tags-configuration))

(rf/reg-event-fx :export-tags/open-ocp
  (fn [{:keys [db]} [_ export-target adset-ids]]
    (when (seq adset-ids)
      (-> {:db db}
          (mr/conj-fx [:dispatch [:ocp/open {:id :export-tags-configuration-ocp
                                             :props {:export-target export-target
                                                     :adset-ids adset-ids}}]])))))

(rf/reg-event-fx :export-tags.excel/on-success
  (fn [{:keys [db]} [_ response]]
    (-> {:db db}
        (mr/conj-fx [:dispatch [:ocp/close]])
        (effect/on-export-excel-tags-success response))))

(rf/reg-event-fx :export-tags.excel/on-failure
  (fn [{:keys [db]} [_ error]]
    (-> {:db db}
        (effect/on-export-excel-tags-failure error))))

(defn- export-html-tags [effects {:keys [token url-context dsps additional-settings extra-dsp-signals advertiser-id adset-ids]}]
  (-> effects
      (effect/set-campaign-tags-resource {:state :pending})
      (effect/create-campaign-tags-page {:token token
                                         :url-context url-context
                                         :dsps dsps
                                         :additional-settings additional-settings
                                         :extra-dsp-signals extra-dsp-signals
                                         :advertiser-id advertiser-id
                                         :adset-ids adset-ids
                                         :on-success [:export-tags.html/on-success]
                                         :on-failure [:export-tags.html/on-failure]})))

(rf/reg-event-fx :export-tags.html/on-success
  (fn [{:keys [db]} [_ campaign-tags-page]]
    (-> {:db db}
        (effect/set-campaign-tags-resource {:state :success
                                            :value campaign-tags-page})
        (effect/set-campaign-tags-settings campaign-tags-page)
        (effect/navigate-to-campaign-page (:id campaign-tags-page))
        (mr/conj-fx [:dispatch [:ocp/close]]))))

(rf/reg-event-fx :export-tags.html/on-failure
  (fn [{:keys [db]} _]
    (-> {:db db}
        (effect/set-campaign-tags-resource {:state :failure}))))

(rf/reg-event-fx :form.export-tags-configuration/on-submit-button-clicked
  [(rf/inject-cofx :sub :resource.user/token)
   (rf/inject-cofx :sub :url-context)]
  (fn [{:keys [db resource.user/token url-context]} [_ {:keys [dsp-ids additional-settings extra-dsp-signals]} export-target adset-ids]]
    (let [dsps (->> dsp-ids
                    (keep (fn [[dsp-id checked]]
                            (when checked dsp-id)))
                    vec)]
      (-> {:db db}
          (cond-> (= export-target :excel-file)
            (effect/export-excel-tags {:token token
                                       :url-context url-context
                                       :dsps dsps
                                       :additional-settings additional-settings
                                       :extra-dsp-signals extra-dsp-signals
                                       :advertiser-id (:advertiser-id url-context)
                                       :adset-ids adset-ids
                                       :on-success [:export-tags.excel/on-success]
                                       :on-failure [:export-tags.excel/on-failure]}))
          (cond-> (= export-target :html-file)
            (export-html-tags {:token token
                               :url-context url-context
                               :dsps dsps
                               :additional-settings additional-settings
                               :extra-dsp-signals extra-dsp-signals
                               :advertiser-id (:advertiser-id url-context)
                               :adset-ids adset-ids}))))))
